/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { BrickLoader } from "@nordcloud/gnui";
import {
  Resource,
  ResourceUpdateStatus,
  UpdateStatusForResource,
} from "~/generated/graphql";
import { StatusLink } from "~/views/resources/ResourceUpdateStatus";
import { buildResourceUpdateStatusLink } from "~/views/resources/ResourceUpdateStatus/UpdatesModal/utils";

type Props = {
  updateStatusesLoading: boolean;
  updateStatuses: UpdateStatusForResource[];
  resource: Resource;
};

export function ResourceUpdateStatusCell({
  updateStatusesLoading,
  updateStatuses,
  resource,
}: Props) {
  if (updateStatusesLoading) {
    return <BrickLoader height={"2rem"} />;
  }

  const statusData = updateStatuses.find(
    (status) => status.resourceId === resource.id
  );
  const status =
    statusData?.updateStatus ?? ResourceUpdateStatus.NoPendingUpdates;

  const basedOn = statusData?.basedOn;
  const linkTo =
    basedOn && statusData
      ? buildResourceUpdateStatusLink({
          resourceId: statusData.resourceId,
          eventId: basedOn.eventId,
          eventActionId: basedOn.eventActionId,
          status,
        })
      : undefined;

  return (
    <StatusLink
      status={status}
      to={linkTo}
      count={statusData?.pendingUpdateCount}
    />
  );
}
